import React, { useContext } from 'react';
import { Field } from 'formik';
import Select from 'react-select';
import { appendValidationClassNames } from './utils';
import { FormContext } from './FormContext';
const SelectField = React.forwardRef((props, ref) => {
    const context = useContext(FormContext);
    const { disabled, readOnly } = context ? context : {};
    const extProps = { disabled, readOnly, ...props };
    const customStyles = {
        control: (base) => ({
            ...base,
            height: 36,
            minHeight: 36,
        }),
    };
    return (
        <Field
            {...extProps}
            render={({ field, form, form: { touched, errors } }) => {
                let classes = props.className;
                if (extProps.disabled !== true) {
                    classes = appendValidationClassNames(props.className, touched, errors, field.name);
                }

                const fValue = field.value ? (typeof field.value === 'string' ? field.value : field.value.value) : '';
                let valueCalculated = props.options ? props.options.find((option) => option.value === fValue) : '';

                //array.find method returns undefined and Select ignores this value, convert it to Null to make reset of value working
                if (!valueCalculated) {
                    valueCalculated = null;
                }

                return (
                    <Select
                        {...field}
                        {...extProps}
                        isDisabled={extProps.disabled}
                        ref={ref}
                        value={valueCalculated}
                        classNamePrefix="tpc-select"
                        onChange={(option) => {
                            form.setFieldValue(field.name, props.setOnlyValueOnChange ? option.value : option);
                            //{currentTarget: {value: option, name: props.name}}
                            if (props.onChange) props.onChange(option);
                        }}
                        onBlur={(event) => {
                            form.setFieldTouched(field.name, true);
                            if (typeof props.onBlur === 'function') props.onBlur(event);
                        }}
                        className={classes}
                        styles={customStyles}
                    />
                );
            }}
        />
    );
});

SelectField.displayName = 'SelectField';

export default SelectField;
